import { atom, useAtom } from "jotai";

export const showEquityModalAtom = atom<boolean>(false);

export const useShowEquityModal = () => {
  const [showEquityModal, setShowEquityModal] = useAtom(showEquityModalAtom);

  return {
    showEquityModal,
    setShowEquityModal,
  };
};
